import Image from 'next/image';
import Link from 'next/link';
import React, { useEffect, useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { getClickLinkParams } from '../../../../common/utils/appLinkUtil';

import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import PGMBoxBTNArea from './PGMBoxBTNArea';
import cookieCutter from "cookie-cutter";
import axios from "axios";

export default function pgmbox(props) {

  let [maxPageCount, setMaxPageCount] = useState(0);
  let [naviCount, setNaviCount] = useState(1);

  // ✅ pgmIdList 만들기
  const pgmIdList = props.data.contents
      .map((item) => item.smr_pgm_id)
      .filter((id) => !!id);

  // ✅ 구독 상태 Map과 fetch 여부
  const [subscriptionMap, setSubscriptionMap] = useState({});
  const [subscriptionFetched, setSubscriptionFetched] = useState(false);

  useEffect(() => {
    setMaxPageCount(props.data.contents.length / 5);

  }, [])


  // ✅ 구독 상태를 한 번만 가져오기
  useEffect(() => {
    const fetchSubscriptions = async () => {
      const LOGIN_JWT = cookieCutter.get('LOGIN_JWT');
      if (!LOGIN_JWT || pgmIdList.length === 0) return;

      const joinedIds = pgmIdList.join(',');
      const apiUrl = `https://apis.sbs.co.kr/play-api/1.0/subscription/program/${joinedIds}?jwt-token=${LOGIN_JWT}`;

      try {
        const response = await axios.get(apiUrl);
        setSubscriptionMap(response.data || {});
        setSubscriptionFetched(true);
      } catch (error) {
        console.error('Error fetching subscriptions:', error);
      }
    };

    fetchSubscriptions();
  }, [pgmIdList.join(',')]);

  useEffect(() => {
    //alert('www');
    window.__SBSLogModuleDataLayer = window.__SBSLogModuleDataLayer || [];
  }, []);
  //link로그를
  const handleClick = (a,b,c,d,e) => {
    //통계에 넙겨줄 값을정리한다,상단여역 pgmbox 프로그램 / 메뉴 / 플레이톡이 있음
    window.__SBSLogModuleDataLayer.push({
      type: 'content',
      option: {
        moduleId: '큐레이션 모듈', //모듈 아이디 없으면
        moduleTitle: e, //모듈 제목 (Require)
        moduleSubTitle: '프로그램테마 큐레이션',
        moduleActive: 'C', //콘텐츠 선택 정보 Click: C, Hover: H
        moduleSeq: props.loc_idx, //페이지에서 해당 모듈의 위치
        moduleItemSeq: c, //모듈 내에서 콘텐츠의 위치
        programId: b.pgm_id, //프로그램의 아이디 (추가)
        programTitle: b.pgm_nm, //프로그램의 아이디 (추가)
        contentId:  b.pgm_id,//식별자
        contentTitle: b.img_attr, //콘텐츠의 제목  (Require)
        contentNumber: '',
        contentType: 'PR', //콘텐츠의 타입 (별도 표 참조)
      }
    });
  };

  return (

    <>
      {/* <!-- 인기 프로그램 -->*/}
      <div className="mainContents-typeWhite">
        <div className="contentsBlock_w" >
          <div className="moduleTitleline_w">
            <h2 className="moduleTitleline-Title">{props.data.list_title}</h2>
            <a href={props.data.alllink_url} className="moduleTitleline-linkMore" style={{ visibility: (props.data.alllink_yn == 'Y' && props.data.alllink_url != '' && props.data.alllink_url != null) ? 'visible' : 'hidden' }}>{props.data.alllink_title}</a>
          </div>
          <div className={"listModule_w_program program" + props.loc_idx}>
            <div className="listModuleSlider listScrollSlider">
              {/* <!-- 리스트 -->*/}
              <div className="SliderContent swiper-wrapper">
                {
                  props.data.contents.map((item, index) => {

                    return (

                      <div className="listModuleItem swiper-slide">
                        <div className="modulePosterWrap">
                          <Link href={item.link_url} >
                            <a   onClick={(e) => handleClick(e, item,index,'인기', props.data.list_title)} className="mp_link">
                              <div className="mp_image_w">
                                <div className="mp_image_inner">
                                  <img src={item.img_url} className="mp_image" alt={item.img_attr} />
                                </div>
                                <div className="mb_label_w">
                                  {
                                    item.free_yn == 'Y' ? (<><span className="mb_label_free">FREE</span></>) : (<></>)
                                  }
                                  {
                                    item.age19_yn == 'Y' ? (<><span className="mb_label_19">19+</span></>) : (<></>)
                                  }
                                </div>
                              </div>
                              <div className="mp_info_w">
                                <span className="mpif_title">{item.pgm_nm}</span>
                                {
                                  item.new_yn == 'Y' ? (<><span className="mp_label_new"><i className="hide">신작</i></span></>) : (<></>)
                                }
                              </div>
                            </a>
                          </Link>

                        

                          <PGMBoxBTNArea
                              key={`mb_${index}`}
                              data={item}
                              pgmIdList={pgmIdList}
                              subscriptionMap={subscriptionMap}
                              subscriptionFetched={subscriptionFetched}
                              clickParams={props.clickParamLink}
                          />


                        </div>
                      </div>
                    )
                  })
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </>

  );

}